import Roles from "../../features/dashboard/roles/Roles"

function RolesDB() {
    return <Roles />
}

export default RolesDB